import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

import { mapDataToUndefinedIfSkip } from 'modules/api/utils';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { useGlobalTranslation } from 'modules/i18n';
import { useGetLSPendingUnstakesQuery } from 'modules/liquidStaking/actions/getPendingUnstakes';
import { useLiquidStakingPool } from 'modules/liquidStaking/hooks/useLiquidStakingPool';

import { StakingTable as Table } from '../StakingTable';
import { TableRow } from './TableRow';
import { translation } from './translation';

export function PendingLiquidStaking(): ReactElement | null {
  const { t, keys } = useGlobalTranslation(translation);

  const { isConnected, connectionKey, cacheTime } = useConnection();
  const { poolAddress } = useLiquidStakingPool();
  const { data: poolUnstakes } = useGetLSPendingUnstakesQuery(
    { connectionKey, poolAddress },
    {
      skip: !isConnected,
      selectFromResult: mapDataToUndefinedIfSkip,
      refetchOnMountOrArgChange: cacheTime,
    },
  );

  if (!poolUnstakes?.length) {
    return null;
  }

  return (
    <Box
      sx={theme => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <Typography fontWeight={600} textTransform="uppercase" variant="body1">
        {t(keys.title)}
      </Typography>

      <Table>
        <Table.Head>
          <Table.Row>
            <Table.HeadCell>{t(keys.asset)}</Table.HeadCell>

            <Table.HeadCell>{t(keys.amount)}</Table.HeadCell>

            <Table.HeadCell>{t(keys.initiated)}</Table.HeadCell>

            <Table.HeadCell> </Table.HeadCell>
          </Table.Row>
        </Table.Head>

        <Table.Body>
          {poolUnstakes.map(unstake => (
            <TableRow key={unstake.id} poolUnstake={unstake} />
          ))}
        </Table.Body>
      </Table>
    </Box>
  );
}
